import React from 'react';
import './jelly-loader.scss';

const JellyLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="jelly-loader-container">
      <div className="jelly-loader">
        <div className="jelly-icon">
          <img 
            src="/assets/images/small_icon_withBg.png" 
            alt="Jely Logo" 
            className="logo-bounce"
          />
        </div>
        <div className="loading-dots">
          <span className="dot dot-1"></span>
          <span className="dot dot-2"></span>
          <span className="dot dot-3"></span>
        </div>
        
      </div>
    </div>
  );
};

export default JellyLoader;
